import { all, call, put, takeLatest } from "redux-saga/effects";
import destinationService from "../../services/destinationService";
import { destinationActions } from "../slices/destinationSlice";

function* destinationsFetchSaga() {
  try {
    const data = yield call(destinationService.getDestinations);

    yield put(destinationActions.destinationsSuccess(data));
  } catch (e) {
    yield put(destinationActions.destinationsError(e.response.data));
  }
}

function* destinationsByDateFetchSaga({ payload }) {
  try {
    const data = yield call(destinationService.getDestinationsByDate, payload);

    yield put(destinationActions.destinationsByDateSuccess(data));
  } catch (e) {
    yield put(destinationActions.destinationsByDateError(e.response.data));
  }
}

function* createDestinationsPostSaga({ payload }) {
  try {
    const data = yield call(destinationService.createDestination, {
      name: payload.name,
      destinationType: payload.destinationType,
    });
    yield put(destinationActions.createDestinationsSuccess(data));
    yield call(payload.onSuccess);
  } catch (e) {
    yield put(destinationActions.createDestinationsError(e.response.data));
    yield call(payload.onError);
  }
}

export default function* destinationSaga() {
  yield all([
    takeLatest("destination/destinationsFetch", destinationsFetchSaga),
    takeLatest(
      "destination/destinationsByDateFetch",
      destinationsByDateFetchSaga
    ),
    takeLatest(
      "destination/createDestinationsPost",
      createDestinationsPostSaga
    ),
  ]);
}
